<template>
    <v-menu open-on-hover transition="slide-x-transition"  offset-y>
      <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-badge
              :content="totalNotifications"
              :value="totalNotifications"
              overlap
            >
            <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
      </template>
      <v-card class="mx-auto" max-width="300" max-height="400" tile>
          <v-list >
              <v-subheader>
                <v-row>

                  <v-col><span>{{$t('menu.notification.notifications')}}</span></v-col>
                  <v-col><router-link class="float-right" :to="{ name: 'NotificationList' }">{{$t('global.viewall')}}</router-link></v-col>
                </v-row>
              </v-subheader>

              <v-divider></v-divider>

              <v-list-item-group >
                <div v-for="notification in this.notifications" :key="notification.id">
                  <v-list-item  router :to="{ name: 'NotificationShow', params: { id: notification['@id'] } }">
                      <v-list-item-action>
                          <v-icon>{{ icon(notification.type.type) }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                          <v-list-item-subtitle>{{ $t(notification.type.name, notification.data) }}</v-list-item-subtitle>
                      </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list-item-group>
              <v-divider></v-divider>
              <v-container>
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-btn

                    class="ma-2 white--text"
                    color="error"
                    @click="viewall"
                  >{{$t('global.clear')}}
                  <v-icon right dark>mdi-delete-circle</v-icon>

                  </v-btn>
              </v-row>
            </v-container>
          </v-list>
        </v-card>
      </v-menu>
</template>

<script>

import { mapActions,mapState,mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import NotificationMixin from '../../mixins/NotificationMixin';
import ListMixin from '../../mixins/ListMixin';
export default {
  name: 'NotificationNavigation',
  servicePrefix: 'notificationuser',
  mixins: [ListMixin,NotificationMixin],
  props: {

  },
  data: () => ({
    notificationsNoView: null,
    polling: null
  }),
  computed: {
    ...mapState('notificationuser', {
      updatedata: 'updatedata',
    }),
    ...mapFields('notificationuser', {
      actioned: 'actioned',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
    }),
    ...mapGetters('notificationuser',{
      dataNotification: 'data',
    }),
    totalNotifications() {
      if (this.notifications) return this.notifications.length;
      return 0;
    },
    notifications: {
      get() { return this.notificationsNoView },
       set(value) { this.notificationsNoView = value; }
    }
  },
  methods: {
    ...mapActions('notificationuser', {
      fetchAllData: 'fetchAllData',
      notificationuserPushAction: 'action'
    }),
    icon(type) {
      if (type == 'security') return 'mdi-security';
      if (type == 'machine') return 'mdi-printer-3d';
      if (type == 'toolhead') return 'mdi-tools';
      if (type == 'materialsupply') return 'mdi-format-color-fill';
      if (type == 'industrialcomputer') return 'mdi-server';
      if (type == 'controlunit') return 'mdi-car-cruise-control';
      if (type == 'accessory') return 'mdi-cctv';
      if (type == 'sector') return 'mdi-tag';
      if (type == 'tag') return 'mdi-tag';
      if (type == 'verticale') return 'mdi-tag';
      return 'mdi-bell';
    },
    viewall() {
      this.notificationuserPushAction({action: 'viewall',values: {}});
    },
    updatedviewall(actioned) {
      console.log("updatedviewall");
      this.showMessage(actioned.message);
      let params = { 'view' : false  };
      this.fetchAllData({'params': params,'data':'notificationProfil'});
    },
    pollData () {
      // Si la page n'est pas actif, on ne recherche pas de nouvelles notifications
      if (!document.hidden) {
        this.polling = setInterval(() => {
          if (!document.hidden) {
            if (this.$root.isConnected) {
              this.fetchAllData({'params': { 'view' : false  },'data':'notificationProfil'});
            }
                    }
        }, 100000);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  mounted() {
    this.fetchAllData({'params': { 'view' : false  },'data':'notificationProfil'});
    this.pollData()
 },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      if (this.action == 'viewall') {
        this.updatedviewall(actioned);
      }
    },
    updatedata(updatedata) {
      if (updatedata == 'notificationProfil') {
        this.notifications = this.dataNotification('notificationProfil');
      }
    },
    error(message) {
      if (message != 'NotConnected') {
        message && this.showError(message);
      }
    }
  }
};
</script>
